module.exports = __webpack_public_path__ + "9788f41e/img/comment-question-icon.7dd26e04.svg";